const cache = {};
export const debounce = function (name, func, timeout) {
    clearTimeout(cache[name]);
    cache[name] = setTimeout(func, timeout ?? 1000);
}

export default { debounce };
